import type React from 'react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { AuthUser } from '../types/auth.ts';

type Props = {
  user: AuthUser;
  onLogout: () => void;
  children: ReactNode;
};

/**
 * 認証済みページ共通のレイアウト（ヘッダー + ナビ + メイン）。
 * 1ファイル1コンポーネント方針に従う。
 */
export const DashboardLayout = ({ user, onLogout, children }: Props): React.JSX.Element => (
  <>
    <header style={headerStyle}>
      <div style={leftBoxStyle}>
        <Link to="/" style={titleLinkStyle}>
          <h1 style={titleStyle}>🔭 TrendScope</h1>
        </Link>
        <nav style={navStyle}>
          <Link to="/" style={navLinkStyle}>ダッシュボード</Link>
          <Link to="/settings" style={navLinkStyle}>設定</Link>
        </nav>
      </div>
      <div style={userBoxStyle}>
        <span>{user.display_name ?? user.email}</span>
        <button type="button" onClick={onLogout} style={logoutBtnStyle}>
          ログアウト
        </button>
      </div>
    </header>
    <main style={mainStyle}>{children}</main>
  </>
);

const headerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 24px',
  borderBottom: '1px solid #e0e0e0',
  background: '#fafafa',
};

const leftBoxStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 24,
};

const titleLinkStyle: React.CSSProperties = {
  textDecoration: 'none',
  color: 'inherit',
};

const titleStyle: React.CSSProperties = {
  margin: 0,
  fontSize: 20,
};

const navStyle: React.CSSProperties = {
  display: 'flex',
  gap: 12,
};

const navLinkStyle: React.CSSProperties = {
  fontSize: 14,
  color: '#1976d2',
  textDecoration: 'none',
};

const userBoxStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  fontSize: 14,
};

const logoutBtnStyle: React.CSSProperties = {
  padding: '6px 12px',
  fontSize: 13,
  background: '#fff',
  border: '1px solid #d0d0d0',
  borderRadius: 4,
  cursor: 'pointer',
};

const mainStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 1080,
  margin: '24px auto',
  padding: '0 24px',
};
